import { useTranslation } from "react-i18next";
import { leaseSteps } from "@/mocks/siteData";
import { waLink } from "@/lib/links";
import SectionHeading from "@/components/feature/SectionHeading";

export default function HowToLeaseSection() {
  const { t } = useTranslation();

  return (
    <section id="how" className="py-20 md:py-28 bg-foreground-900 relative overflow-hidden">
      <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-primary-500/20 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        <SectionHeading
          variant="dark"
          eyebrow={t("how.eyebrow")}
          title={t("how.title")}
          subtitle={t("how.subtitle")}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {leaseSteps.map((step, index) => (
            <div
              key={step.id}
              className="relative bg-background-50/5 border border-background-50/10 hover:border-primary-400 rounded-lg p-7 transition"
            >
              <div className="font-heading text-primary-400 text-5xl font-extrabold opacity-30 leading-none">
                {step.number}
              </div>
              <div className="mt-3 w-12 h-12 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className={`${step.icon} text-xl w-6 h-6 flex items-center justify-center`} />
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-background-50">
                {t(`how.${step.id}.title`)}
              </h3>
              <p className="mt-3 text-background-50/70 text-sm leading-relaxed">
                {t(`how.${step.id}.description`)}
              </p>
              {index < leaseSteps.length - 1 && (
                <i className="hidden lg:flex ri-arrow-right-line absolute -right-5 top-1/2 -translate-y-1/2 text-primary-400 text-2xl w-6 h-6 items-center justify-center" />
              )}
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a
            href={waLink(t("wa.how"))}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-7 py-4 rounded-md whitespace-nowrap cursor-pointer transition"
          >
            <i className="ri-whatsapp-line text-xl w-5 h-5 flex items-center justify-center" />
            {t("how.cta")}
          </a>
        </div>
      </div>
    </section>
  );
}